import * as React from 'react';

import { PrimaryCta } from 'components/Buttons';

import {
  NotificationModal,
  useOpenNotificationModal
} from 'catering/components/Modals';

function CartNoLongerExistsNotification() {
  const handlePrimaryCtaClick = () => {
    window.location.reload();
  };

  return (
    <NotificationModal
      title="This cart no longer exists"
      text="Please refresh the page to create a new cart and continue shopping."
    >
      <PrimaryCta
        label="Refresh"
        handleClick={handlePrimaryCtaClick}
        fullWidth
      />
    </NotificationModal>
  );
}

export function useOpenCartNoLongerExistsNotificationModal() {
  return useOpenNotificationModal(<CartNoLongerExistsNotification />);
}
